
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Hook to fetch region details with better error handling
 */
export const useRegionDetails = (selectedRegion: string) => {
  return useQuery({
    queryKey: ['region', selectedRegion],
    queryFn: async () => {
      try {
        if (!selectedRegion) return null;
        
        const { data, error } = await supabase
          .from('regions')
          .select('*')
          .eq('code', selectedRegion)
          .maybeSingle();
          
        if (error) {
          console.error("Error fetching region details:", error);
          // Return fallback data instead of throwing
          return {
            name: selectedRegion,
            code: selectedRegion,
            currency: 'Ksh',
            timezone: 'Africa/Nairobi'
          };
        }
        
        return data;
      } catch (err) {
        console.error("Unexpected error in useRegionDetails:", err);
        // Return fallback data for any unexpected errors
        return {
          name: selectedRegion,
          code: selectedRegion,
          currency: 'Ksh',
          timezone: 'Africa/Nairobi'
        };
      }
    },
    // Longer stale time for region data since it rarely changes
    staleTime: 60 * 60 * 1000, // 1 hour
    // Return last known good data if available on error
    placeholderData: (previousData) => previousData
  });
};
